import { Component, OnInit, TemplateRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { UserService, ShowHideInput, PatientService, User } from '../../shared';
import { BsModalService } from 'ngx-bootstrap/modal';
import { environment } from '../../shared/config/app-config';

@Component({
  selector: 'app-profilepage',
  templateUrl: './profilepage.component.html',
  styleUrls: ['../style.component.css']
})
export class ProfilepageComponent implements OnInit {
  params: any;
  ques: any;
  app: any;
  public myobj: any = {};
  public carepath: any = {};
  public apiurl: any = environment.api_url;
  public obj: any = {};
  public myobj1: any = {};
  resabs: any;
  resab: any;
  modalRef: any;
  // public imageURL:string;
  public currentUser: User;

  constructor(

    private activeroute: ActivatedRoute,
    private routers: Router,
    private patientservice: PatientService,
    private modalService: BsModalService,
    private userservic: UserService,
  ) { }

  ngOnInit() {

    this.activeroute.params.subscribe(params => {
      this.params = params

      //////console.log(this.params.id)
    });
    this.userservic.currentUser.subscribe(
      (userData) => {
        this.currentUser = userData;
      }
    )

    //   if(this.currentUser.item.hostModel=="CLOUD")
    //   this.imageURL = environment.cloudeImageURL;
    // else   
    //   this.imageURL = environment.vmImageURL;



    this.patientservice
      .getprofile(this.params.patid)
      .subscribe(
        data => {

          this.ques = data.profileQuestions;
        }
      );
    /* if(window.localStorage['pwd']){
        this.obj = JSON.parse( window.localStorage['pwd']);
  
        this.myobj1 = JSON.stringify(this.obj);
        ////console.log(this.myobj)
        ////console.log(this.obj.userFnLn)
       }
      else{
  ////console.log("logout")
  this.routers.navigate([`/login`])
      }  */
    if (window.localStorage['pwd']) {
      this.carepath = JSON.parse(window.localStorage['pwd']);
      this.myobj1 = JSON.stringify(this.carepath);
      ////console.log("care",this.carepath.userFnLn)
    }
    else {
      this.routers.navigate([`/login`])
    }
  }


  // this.routers.navigate([`/login`])
  redirect(){
    this.routers.navigate([`/upload/${this.params.id}`])
  }
  savequestion(myobj) {
    this.patientservice.savequestion(myobj)
      .subscribe(
        data => {
          //////console.log(data);
          if (data.updateStatus == "true") {
            this.routers.navigate([`/helpdesk`])
          } else {
            this.resabs = this.userservic.translateText('hospital_portal.disp_messages.enter_valid_data.errormsg');

          }

        }
      );
  }


  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, { class: 'modal-sm', backdrop: 'static' });
  }


  submitabout() {
    this.resabs = " ";
    this.myobj.profileQuestions = "";
    this.myobj.profileQuestions = this.ques;
    if (this.myobj.profileQuestions[0].answer != "" && this.myobj.profileQuestions[1].answer != "" && this.myobj.profileQuestions[2].answer != "" && this.myobj.profileQuestions[3].answer != "") {
      this.myobj.userAccountId = this.params.patid;
      this.savequestion(this.myobj);

    } else {
      this.resabs = this.userservic.translateText('patient_portal.validations.enter_all_fields.error_label');
    }
  }

}
